import React from "react";
import Seo from "../components/Generic/Seo"; // Import Seo component
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";

const CommunityForum = () => {
  const seoData = {
    title: "Community Forum | Wise Community Discussions & Collaboration",
    description:
      "Join the Wise Community Forum to connect with peers, share ideas, discuss topics, and collaborate on empowering women in semiconductors and technology.",
    keywords:
      "Community Forum, Wise community, discussions, collaboration, women in technology, semiconductors",
    pathSlug: "community-forum",
  };

  return (
    <>
      <Seo data={seoData} />

       <GoogleAnalytics
        page={seoData.pathSlug}
        title={ seoData.title}
      />

      <div className="p-5">
        <h1>Community Forum</h1>
        <p>This is the CommunityForum page content.</p>
      </div>
    </>
  );
};

export default CommunityForum;
